import { array } from '@ember/helper';
import { BreadcrumbsItem } from 'core/components';

<template>
  <BreadcrumbsItem
    @icon="file-text"
    @route="cloud.orgs.detail.projects.detail"
    @models={{array
      @controller.model.organization.id
      @controller.model.project.id
    }}
    @text={{@controller.model.project.name}}
  />

  {{outlet}}
</template>
